import React, { Component } from "react";
import { Form, Grid, Input } from "semantic-ui-react";
import { ERR_TEXTBOX_NOT_FILLED } from "../../../ErrorMessages";
import InlineError from "../../messages/InlineError";

class TextControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultData === undefined ? "" : props.defaultData,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(nextProps.control.FieldId);
      if (element) element.focus();
    }
    this.setState({
      value: nextProps.defaultData === undefined ? "" : nextProps.defaultData,
    });
  }

  onChange = (e, data) => {
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  render() {
    const { control, isLeftSearch } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`txt_${control.FieldId}`}>
        <Grid.Column width={isLeftSearch ? 6 : 6}>
          <Form.Field>
            <label
              htmlFor={control.FieldLabel}
              style={{ color }}
              className="padding-5"
            >
              {control.FieldLabel}
            </label>
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field error={!!control.error}>
            <Input
              id={control.FieldId}
              type="text"
              name={control.FieldName}
              placeholder={control.FieldLabel}
              onChange={this.onChange}
              value={this.state.value}
              size="small"
            />
            {this.props.errors[control.FieldName] !== undefined &&
              this.props.errors[control.FieldName] !== "" && (
                <InlineError text={ERR_TEXTBOX_NOT_FILLED} />
              )}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default TextControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/TextControl.js